import { getSystemAction } from '@libs/store';
import { ActionSystemActionType, TCommonData, TWAction, TWidget } from '@libs/types';
import { useEffect, useEffectEvent } from 'react';
import { useTriggerAction } from './hookTriggerAction';

export const addHistory = (action: TWAction) => {
    window.history.pushState({ action: action }, '');
};

export const useNavigationBlockerViaHistory = (shouldBlock: boolean) => {
    const systemActionNavigateBack = getSystemAction(ActionSystemActionType.navigateBack);
    const { triggerAction } = useTriggerAction({} as TWidget<TCommonData>, true);

    const handlePopState = useEffectEvent((event: PopStateEvent) => {
        event.preventDefault();
        if (shouldBlock && systemActionNavigateBack) {
            triggerAction(systemActionNavigateBack.action, { widgetAction: systemActionNavigateBack.widget }).then();
        }
    });

    useEffect(() => {
        window.addEventListener('popstate', handlePopState);
        return () => {
            window.removeEventListener('popstate', handlePopState);
        };
    }, []);
};
